var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bikeing-station-map-wrapper"},[_c('GmapMap',{ref:"mapRef",staticClass:"custom-map",staticStyle:{"width":"400px","height":"300px"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"map-type-id":"roadmap"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }